import styled from "@emotion/styled";
import { SizeListWrapper } from "src/molecules/SizeSelector/SizeSelectorDropdown.styled";
import { StyledDropdown } from "src/atoms/DropDown/Dropdown.styled";

export const Content = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${({ theme }) => theme.space.space16};
`;

export const Image = styled.img`
  height: 150px;
  object-fit: contain;
  width: 100px;
`;

export const DescriptionContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.space.space16};
`;

export const BrandName = styled.span`
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 600;
  line-height: 24px;
`;

export const ProductName = styled.span`
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  line-height: 20px;
`;

export const SizeContent = styled.div`
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  line-height: 20px;

  & > span:first-of-type {
    margin-right: ${({ theme }) => theme.space.space4};
  }
`;

export const PriceContent = styled.div`
  display: inline-flex;
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  gap: ${({ theme }) => theme.space.space8};
  line-height: 20px;

  > span:first-of-type {
    color: ${({ theme }) => theme.colors.tone.black};
    font-weight: 600;
  }
`;

export const ModalContainer = styled.div<{ isHidden?: boolean }>`
  background: ${({ theme }) => theme.colors.tone.white};
  width: 100%;
  max-height: 95vh;
  display: ${({ isHidden }) => (isHidden ? "none" : "flex")};
  flex-direction: column;
  border-radius: 16px 16px 0 0;
  padding: ${({ theme }) => theme.space[3]}px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 100vh;
    max-width: 444px;
    max-height: 90vh;
    border-radius: 4px;
    padding: ${({ theme }) => theme.space[5]}px;
  }

  ${SizeListWrapper} {
    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
      max-height: 142px;
    }
  }

  ${StyledDropdown} .menu {
    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
      max-height: 142px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
